import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { Form, Button, ButtonGroup, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';

import UIModal from '@material-ui/core/Modal';

// import FormBIOi18n from '../../../components/form/i18nForm/FormBIOi18n';

import * as Yup from 'yup';
import ArtisanForm from '../../../app/pages/users/ArtisanForm';
import CustomerForm from '../../../app/pages/users/CustomerForm';
import SupplierForm from '../../../app/pages/users/SupplierForm';
import { CheckBox, FormGroup, Select } from '../../../components/form';
import countriesList from '../../../app/pages/users/countriesList';
import {
  getUserAction,
  updateUserAction
} from '../../../modules/users/Actions';
import { updateCurrnetUserSettingsAction } from '../../../modules/auth/Actions';
import {
  createArtisanTagAction,
  getArtisanTagsAction,
  updateArtisanTagAction
} from '../../../modules/artisanTags/Actions';
import {
  authCurrentDefaultTypeSelecetor,
  authCurrentUserSettings,
  authCurrentUserTypeSelector,
  authUserIdSelector
} from '../../../modules/auth/Selectors';
import { artisanTagByIdSelector } from '../../../modules/artisanTags/Selectors';
import { usersIsLoadingSelector } from '../../../modules/users/Selectors';
import ApplicantForm from '../../../app/pages/users/ApplicantForm';

const LangOptions = [
  { value: 'EN', label: 'English' },
  { value: 'AR', label: 'Arabic' }
];
// const usersOptions = [
// 	{ value: "4", label: "Artisan" },
// 	{ value: "5", label: "Supplier" },
// 	{ value: "6", label: "Customer" },
// ];
const schema = () =>
  Yup.object().shape({
    settingsDefaultCountry: Yup.string().default(''),
    settingsReceiveNotifications: Yup.bool().default(false),
    settingsDefaultCurrency: Yup.string().default(''),
    settingsUILanguage: Yup.string().default('EN')
  });

const Switcher = props => {
  const {
    userId,
    userSettings,
    getUser,
    updateUser,
    isLoading,
    userType,
    userDefaultType,
    UpdateUserType
  } = props;
  const [modalOpen, setModelOpen] = useState(false);
  const [addType, setAddType] = useState('');
  const [formModal, setFormModal] = useState(null);
  const artisanFormNum = 1;
  const supplierFormNum = 2;
  const customerFormNum = 3;
  const applicantFormNum = 4;
  useEffect(() => {
    // console.log(userId);

    getUser(userId);

    // console.log(userSettings);
    console.log(userType);
  }, []);
  const openFormModal = () => {
    setFormModal();
  };
  const openModalHandler = type => {
    if (type !== localStorage.getItem('defaultType')) {
      setAddType(type);
      setModelOpen(true);
    }
  };
  const selectedForm = () => {
    console.log(formModal, 'formModal');
    if (formModal === 1)
      return <ArtisanForm reload={true} staging authId={userId} />;
    else if (formModal === 3) return <CustomerForm staging authId={userId} />;
    else if (formModal === 2) return <SupplierForm staging authId={userId} />;
    else if (formModal === applicantFormNum)
      return <ApplicantForm staging authId={userId} />;
    // return <div>applicant From</div>;
  };
  return (
    <>
      <Modal show={modalOpen} onHide={() => setModelOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to switch profile</Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setModelOpen(false)}>
            No
          </Button>
          <Button
            variant='primary'
            onClick={() => {
              localStorage.setItem('defaultType', addType);
              UpdateUserType(userId, { defaultUserType: addType });
              window.location.reload();
            }}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <Modal  show={formModal} onHide={()=> setFormModal(null)}>
          <Modal.Body >

            {  formModal && <div >{selectedForm()}</div> }
          </Modal.Body>
      </Modal> */}

      <UIModal
        // style={{
        //   width: '60%',
        //   backgroundColor: 'white',
        //   overflow: 'auto',
        //   top: '60%',
        //   left: '50%',
        //   transform: 'translate(-50%, -50%)',
        //   height: '100%',

        //   position: 'absolute',
        //   padding: '50px',
        // }}
        open={formModal}
        onClose={() => setFormModal(null)}
        closeAfterTransition
        BackdropProps={{
          timeout: 500
        }}
      >
        {formModal && (
          <div
            style={{
              width: '60%',
              backgroundColor: 'white',
              overflow: 'auto',
              top: '60%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              height: '100%',

              position: 'absolute',
              padding: '50px'
            }}
          >
            {selectedForm()}
          </div>
        )}
      </UIModal>

      {userDefaultType !== '0' ? (
        <div className='switch-profiles'>
          {userType.length > 1 ? (
            <ul>
              {userType.indexOf('0') !== -1 ? (
                <li
                  className={`${
                    localStorage.getItem('defaultType') === '0' ? 'active' : ''
                  }`}
                  onClick={() => openModalHandler('0')}
                >
                  <a title='Super Admin'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      version='1.1'
                      viewBox='0 0 512 512'
                      xmlSpace='preserve'
                    >
                      <path d='M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148    C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962    c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216    h40C512,443.62,485.371,379.333,437.02,330.98z M256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40    c59.551,0,108,48.448,108,108S315.551,256,256,256z' />
                    </svg>
                  </a>
                </li>
              ) : null}
              {userType.indexOf('1') !== -1 ? (
                <li
                  className={`${
                    localStorage.getItem('defaultType') === '1' ? 'active' : ''
                  }`}
                  onClick={() => openModalHandler('0')}
                >
                  <a title='Admin'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      version='1.1'
                      viewBox='0 0 512 512'
                      xmlSpace='preserve'
                    >
                      <path d='M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148    C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962    c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216    h40C512,443.62,485.371,379.333,437.02,330.98z M256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40    c59.551,0,108,48.448,108,108S315.551,256,256,256z' />
                    </svg>
                  </a>
                </li>
              ) : null}
              {userType.indexOf('3') !== -1 ? (
                <li
                  onClick={() => openModalHandler('3')}
                  className={`${
                    localStorage.getItem('defaultType') === '3' ? 'active' : ''
                  }`}
                >
                  <a title='Artisan'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      viewBox='0 0 512 512'
                    >
                      <path d='m433.914 326.843-14.561 3.604c2.229 9.002 2.967 17.948 2.228 26.809l-56.187-53.203-54.7 51.797-54.701-51.797-54.7 51.797-54.701-51.797-55.857 52.891c-2.806-22.095 4.102-44.88 20.587-67.858h287.902c6.755 9.403 12.081 18.852 15.807 28.105l13.914-5.604c-4.352-10.802-10.566-21.757-18.472-32.561l-63.092-86.221v-87.806h31.763v101.663h15v-116.663h-46.763v-14.999h61.762v175.374h15v-190.374h-76.402c2.768-29.091 22.082-45 55.114-45v-15h-140.077v15h91.791c-.979.795-1.928 1.622-2.847 2.478-11.107 10.349-17.614 24.946-19.038 42.522h-154.814c-1.424-17.574-7.931-32.171-19.038-42.52-.92-.857-1.869-1.684-2.849-2.479h91.793v-15.001h-140.08v15c33.032 0 52.347 15.909 55.114 45h-76.4v190.374h15v-175.374h61.762v15h-46.762v116.663h15v-101.664h31.762v33.879h15v-33.879h69.606v-15h-69.606v-14.999h154.211v15h-69.605v15h69.605v92.708l55.891 76.379h-265.992l55.89-76.379v-43.83h-15v38.928l-63.091 86.221c-21.675 29.621-29.301 59.445-22.667 88.643 11.164 49.134 60.706 86.414 102.824 109.94l-17.196 34.39h84.736v-15h-60.465l7.5-15h128.43l7.5 15h-67.965v15h92.234l-17.199-34.398c32.818-18.394 57.984-38.89 74.858-60.99 21.781-28.524 28.928-58.727 21.243-89.769zm-232.62 49.665 54.7-51.797 54.701 51.797 54.7-51.797 52.789 49.984c-1.541 5.006-3.572 9.977-6.08 14.909l-46.709-44.237-54.7 51.797-54.701-51.797-54.7 51.797-54.701-51.797-45.27 42.866c-2.586-4.686-4.787-9.51-6.54-14.465l51.81-49.059zm175.074 56.475h-113.59v15h94.189c-9.387 6.551-19.707 12.9-30.983 19.017h-133.914c-10.153-5.503-20.881-11.86-31.417-19.017h87.125v-15h-107.259c-11.688-9.603-22.417-20.264-30.948-31.9l37.022-35.057 54.701 51.797 54.7-51.797 54.701 51.797 54.7-51.796 38.804 36.751c-1.099 1.582-2.247 3.16-3.448 4.733-6.677 8.742-14.837 17.242-24.383 25.472z' />
                      <path
                        d='m139.093 393.197h15v15h-15z'
                        transform='matrix(.707 -.707 .707 .707 -240.399 221.018)'
                      />
                      <path
                        d='m248.494 393.197h15v15h-15z'
                        transform='matrix(.707 -.707 .707 .707 -208.357 298.376)'
                      />
                      <path
                        d='m357.895 393.197h15v15h-15z'
                        transform='matrix(.707 -.707 .707 .707 -176.314 375.735)'
                      />
                      <path
                        d='m193.793 313.68h15v15h-15z'
                        transform='matrix(.707 -.707 .707 .707 -168.151 236.407)'
                      />
                      <path
                        d='m303.194 313.679h15v15h-15z'
                        transform='matrix(.707 -.707 .707 .707 -136.108 313.775)'
                      />
                      <path d='m302.384 30h15v15h-15z' />
                      <path d='m302.384 119.999h15v15h-15z' />
                      <path d='m302.384 149.999h15v45h-15z' />
                    </svg>
                  </a>
                </li>
              ) : (
                <li onClick={() => setFormModal(artisanFormNum)}>
                  <a title='Add Artisan'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      viewBox='0 0 512 512'
                    >
                      <path d='m433.914 326.843-14.561 3.604c2.229 9.002 2.967 17.948 2.228 26.809l-56.187-53.203-54.7 51.797-54.701-51.797-54.7 51.797-54.701-51.797-55.857 52.891c-2.806-22.095 4.102-44.88 20.587-67.858h287.902c6.755 9.403 12.081 18.852 15.807 28.105l13.914-5.604c-4.352-10.802-10.566-21.757-18.472-32.561l-63.092-86.221v-87.806h31.763v101.663h15v-116.663h-46.763v-14.999h61.762v175.374h15v-190.374h-76.402c2.768-29.091 22.082-45 55.114-45v-15h-140.077v15h91.791c-.979.795-1.928 1.622-2.847 2.478-11.107 10.349-17.614 24.946-19.038 42.522h-154.814c-1.424-17.574-7.931-32.171-19.038-42.52-.92-.857-1.869-1.684-2.849-2.479h91.793v-15.001h-140.08v15c33.032 0 52.347 15.909 55.114 45h-76.4v190.374h15v-175.374h61.762v15h-46.762v116.663h15v-101.664h31.762v33.879h15v-33.879h69.606v-15h-69.606v-14.999h154.211v15h-69.605v15h69.605v92.708l55.891 76.379h-265.992l55.89-76.379v-43.83h-15v38.928l-63.091 86.221c-21.675 29.621-29.301 59.445-22.667 88.643 11.164 49.134 60.706 86.414 102.824 109.94l-17.196 34.39h84.736v-15h-60.465l7.5-15h128.43l7.5 15h-67.965v15h92.234l-17.199-34.398c32.818-18.394 57.984-38.89 74.858-60.99 21.781-28.524 28.928-58.727 21.243-89.769zm-232.62 49.665 54.7-51.797 54.701 51.797 54.7-51.797 52.789 49.984c-1.541 5.006-3.572 9.977-6.08 14.909l-46.709-44.237-54.7 51.797-54.701-51.797-54.7 51.797-54.701-51.797-45.27 42.866c-2.586-4.686-4.787-9.51-6.54-14.465l51.81-49.059zm175.074 56.475h-113.59v15h94.189c-9.387 6.551-19.707 12.9-30.983 19.017h-133.914c-10.153-5.503-20.881-11.86-31.417-19.017h87.125v-15h-107.259c-11.688-9.603-22.417-20.264-30.948-31.9l37.022-35.057 54.701 51.797 54.7-51.797 54.701 51.797 54.7-51.796 38.804 36.751c-1.099 1.582-2.247 3.16-3.448 4.733-6.677 8.742-14.837 17.242-24.383 25.472z' />
                      <path
                        d='m139.093 393.197h15v15h-15z'
                        transform='matrix(.707 -.707 .707 .707 -240.399 221.018)'
                      />
                      <path
                        d='m248.494 393.197h15v15h-15z'
                        transform='matrix(.707 -.707 .707 .707 -208.357 298.376)'
                      />
                      <path
                        d='m357.895 393.197h15v15h-15z'
                        transform='matrix(.707 -.707 .707 .707 -176.314 375.735)'
                      />
                      <path
                        d='m193.793 313.68h15v15h-15z'
                        transform='matrix(.707 -.707 .707 .707 -168.151 236.407)'
                      />
                      <path
                        d='m303.194 313.679h15v15h-15z'
                        transform='matrix(.707 -.707 .707 .707 -136.108 313.775)'
                      />
                      <path d='m302.384 30h15v15h-15z' />
                      <path d='m302.384 119.999h15v15h-15z' />
                      <path d='m302.384 149.999h15v45h-15z' />
                    </svg>
                  </a>
                </li>
              )}
              {userType.indexOf('4') !== -1 ? (
                <li
                  onClick={() => openModalHandler('4')}
                  className={`${
                    localStorage.getItem('defaultType') === '4' ? 'active' : ''
                  }`}
                >
                  <a title='Customer'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      version='1.1'
                      viewBox='0 0 512 512'
                      xmlSpace='preserve'
                    >
                      <path d='M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148    C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962    c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216    h40C512,443.62,485.371,379.333,437.02,330.98z M256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40    c59.551,0,108,48.448,108,108S315.551,256,256,256z' />
                    </svg>
                  </a>
                </li>
              ) : (
                <li onClick={() => setFormModal(customerFormNum)}>
                  <a title='Add Customer'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      version='1.1'
                      viewBox='0 0 512 512'
                      xmlSpace='preserve'
                    >
                      <path d='M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148    C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962    c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216    h40C512,443.62,485.371,379.333,437.02,330.98z M256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40    c59.551,0,108,48.448,108,108S315.551,256,256,256z' />
                    </svg>
                  </a>
                </li>
              )}

              {userType.indexOf('5') !== -1 ? (
                <li
                  onClick={() => openModalHandler('5')}
                  className={`${
                    localStorage.getItem('defaultType') === '5' ? 'active' : ''
                  }`}
                >
                  <a title='Supplier'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      viewBox='0 0 512 512'
                    >
                      <path d='M491.729,112.971L259.261,0.745c-2.061-0.994-4.461-0.994-6.521,0L20.271,112.971c-2.592,1.251-4.239,3.876-4.239,6.754    v272.549c0,2.878,1.647,5.503,4.239,6.754l232.468,112.226c1.03,0.497,2.146,0.746,3.261,0.746s2.23-0.249,3.261-0.746    l232.468-112.226c2.592-1.251,4.239-3.876,4.239-6.754V119.726C495.968,116.846,494.32,114.223,491.729,112.971z M256,15.828    l215.217,103.897l-62.387,30.118c-0.395-0.301-0.812-0.579-1.27-0.8L193.805,45.853L256,15.828z M176.867,54.333l214.904,103.746    l-44.015,21.249L132.941,75.624L176.867,54.333z M396.799,172.307v78.546l-41.113,19.848v-78.546L396.799,172.307z     M480.968,387.568L263.5,492.55V236.658l51.873-25.042c3.73-1.801,5.294-6.284,3.493-10.015    c-1.801-3.729-6.284-5.295-10.015-3.493L256,223.623l-20.796-10.04c-3.731-1.803-8.214-0.237-10.015,3.493    c-1.801,3.73-0.237,8.214,3.493,10.015l19.818,9.567V492.55L31.032,387.566V131.674l165.6,79.945    c1.051,0.508,2.162,0.748,3.255,0.748c2.788,0,5.466-1.562,6.759-4.241c1.801-3.73,0.237-8.214-3.493-10.015l-162.37-78.386    l74.505-35.968L340.582,192.52c0.033,0.046,0.07,0.087,0.104,0.132v89.999c0,2.581,1.327,4.98,3.513,6.353    c1.214,0.762,2.599,1.147,3.988,1.147c1.112,0,2.227-0.247,3.26-0.746l56.113-27.089c2.592-1.251,4.239-3.875,4.239-6.754v-90.495    l69.169-33.392V387.568z' />
                      <path d='M92.926,358.479L58.811,342.01c-3.732-1.803-8.214-0.237-10.015,3.493c-1.801,3.73-0.237,8.214,3.493,10.015    l34.115,16.469c1.051,0.508,2.162,0.748,3.255,0.748c2.788,0,5.466-1.562,6.759-4.241    C98.22,364.763,96.656,360.281,92.926,358.479z' />
                      <path d='M124.323,338.042l-65.465-31.604c-3.731-1.801-8.214-0.237-10.015,3.494c-1.8,3.73-0.236,8.214,3.494,10.015    l65.465,31.604c1.051,0.507,2.162,0.748,3.255,0.748c2.788,0,5.466-1.562,6.759-4.241    C129.617,344.326,128.053,339.842,124.323,338.042z' />
                    </svg>
                  </a>
                </li>
              ) : (
                <li onClick={() => setFormModal(supplierFormNum)}>
                  <a title='Add Supplier'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      viewBox='0 0 512 512'
                    >
                      <path d='M491.729,112.971L259.261,0.745c-2.061-0.994-4.461-0.994-6.521,0L20.271,112.971c-2.592,1.251-4.239,3.876-4.239,6.754    v272.549c0,2.878,1.647,5.503,4.239,6.754l232.468,112.226c1.03,0.497,2.146,0.746,3.261,0.746s2.23-0.249,3.261-0.746    l232.468-112.226c2.592-1.251,4.239-3.876,4.239-6.754V119.726C495.968,116.846,494.32,114.223,491.729,112.971z M256,15.828    l215.217,103.897l-62.387,30.118c-0.395-0.301-0.812-0.579-1.27-0.8L193.805,45.853L256,15.828z M176.867,54.333l214.904,103.746    l-44.015,21.249L132.941,75.624L176.867,54.333z M396.799,172.307v78.546l-41.113,19.848v-78.546L396.799,172.307z     M480.968,387.568L263.5,492.55V236.658l51.873-25.042c3.73-1.801,5.294-6.284,3.493-10.015    c-1.801-3.729-6.284-5.295-10.015-3.493L256,223.623l-20.796-10.04c-3.731-1.803-8.214-0.237-10.015,3.493    c-1.801,3.73-0.237,8.214,3.493,10.015l19.818,9.567V492.55L31.032,387.566V131.674l165.6,79.945    c1.051,0.508,2.162,0.748,3.255,0.748c2.788,0,5.466-1.562,6.759-4.241c1.801-3.73,0.237-8.214-3.493-10.015l-162.37-78.386    l74.505-35.968L340.582,192.52c0.033,0.046,0.07,0.087,0.104,0.132v89.999c0,2.581,1.327,4.98,3.513,6.353    c1.214,0.762,2.599,1.147,3.988,1.147c1.112,0,2.227-0.247,3.26-0.746l56.113-27.089c2.592-1.251,4.239-3.875,4.239-6.754v-90.495    l69.169-33.392V387.568z' />
                      <path d='M92.926,358.479L58.811,342.01c-3.732-1.803-8.214-0.237-10.015,3.493c-1.801,3.73-0.237,8.214,3.493,10.015    l34.115,16.469c1.051,0.508,2.162,0.748,3.255,0.748c2.788,0,5.466-1.562,6.759-4.241    C98.22,364.763,96.656,360.281,92.926,358.479z' />
                      <path d='M124.323,338.042l-65.465-31.604c-3.731-1.801-8.214-0.237-10.015,3.494c-1.8,3.73-0.236,8.214,3.494,10.015    l65.465,31.604c1.051,0.507,2.162,0.748,3.255,0.748c2.788,0,5.466-1.562,6.759-4.241    C129.617,344.326,128.053,339.842,124.323,338.042z' />
                    </svg>
                  </a>
                </li>
              )}

              {userType.indexOf('6') !== -1 ? (
                <li
                  onClick={() => openModalHandler('6')}
                  className={`${
                    localStorage.getItem('defaultType') === '6' ? 'active' : ''
                  }`}
                >
                  <a title='Applicants'>
                    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 74 74'>
                      <path d='m68.77 54.08h-3.5a1 1 0 0 1 0-2h3.5a1.221 1.221 0 0 0 1.091-1.78 1.013 1.013 0 0 1 -.08-.213l-3.149-12.4a2.307 2.307 0 0 0 -2.012-1.167h-55.24a2.307 2.307 0 0 0 -2.012 1.166l-3.149 12.4a1.013 1.013 0 0 1 -.08.213 1.221 1.221 0 0 0 1.091 1.781h24.52a1 1 0 0 1 0 2h-24.52a3.221 3.221 0 0 1 -2.923-4.587l3.154-12.419a.974.974 0 0 1 .079-.211 4.3 4.3 0 0 1 3.84-2.343h55.24a4.3 4.3 0 0 1 3.84 2.343.974.974 0 0 1 .079.211l3.154 12.419a3.221 3.221 0 0 1 -2.923 4.587z' />
                      <path d='m53.37 54.08h-9.12a1 1 0 0 1 0-2h9.12a1 1 0 0 1 0 2z' />
                      <path d='m60.17 54.08h-1.7a1 1 0 0 1 0-2h1.7a1 1 0 0 1 0 2z' />
                      <path d='m55.2 36.522h-8.942a1 1 0 0 1 -1-1v-3.267a1 1 0 1 1 2 0v2.267h6.942v-2.267a1 1 0 1 1 2 0v3.267a1 1 0 0 1 -1 1z' />
                      <path d='m60.351 36.522h-19.244a1 1 0 0 1 -1-1v-4.056a6.525 6.525 0 0 1 6.519-6.517h8.206a6.525 6.525 0 0 1 6.519 6.517v4.056a1 1 0 0 1 -1 1zm-18.244-2h17.244v-3.056a4.523 4.523 0 0 0 -4.519-4.517h-8.206a4.523 4.523 0 0 0 -4.519 4.517z' />
                      <path d='m50.729 22.85a5.756 5.756 0 1 1 5.755-5.756 5.762 5.762 0 0 1 -5.755 5.756zm0-9.512a3.756 3.756 0 1 0 3.755 3.756 3.759 3.759 0 0 0 -3.755-3.756z' />
                      <path d='m41.472 62.662h-8.944a1 1 0 0 1 -1-1v-3.268a1 1 0 0 1 2 0v2.268h6.944v-2.268a1 1 0 0 1 2 0v3.268a1 1 0 0 1 -1 1z' />
                      <path d='m46.621 62.662h-19.242a1 1 0 0 1 -1-1v-4.056a6.525 6.525 0 0 1 6.521-6.518h8.2a6.525 6.525 0 0 1 6.517 6.518v4.056a1 1 0 0 1 -.996 1zm-18.242-2h17.242v-3.056a4.523 4.523 0 0 0 -4.521-4.518h-8.2a4.523 4.523 0 0 0 -4.517 4.518z' />
                      <path d='m37 48.989a5.756 5.756 0 1 1 5.756-5.755 5.762 5.762 0 0 1 -5.756 5.755zm0-9.511a3.756 3.756 0 1 0 3.756 3.756 3.76 3.76 0 0 0 -3.756-3.756z' />
                      <path d='m27.742 36.522h-8.942a1 1 0 0 1 -1-1v-3.267a1 1 0 1 1 2 0v2.267h6.942v-2.267a1 1 0 1 1 2 0v3.267a1 1 0 0 1 -1 1z' />
                      <path d='m32.893 36.522h-19.244a1 1 0 0 1 -1-1v-4.056a6.525 6.525 0 0 1 6.519-6.517h8.206a6.525 6.525 0 0 1 6.519 6.517v4.056a1 1 0 0 1 -1 1zm-18.244-2h17.244v-3.056a4.523 4.523 0 0 0 -4.519-4.517h-8.206a4.523 4.523 0 0 0 -4.519 4.517z' />
                      <path d='m23.271 22.85a5.756 5.756 0 1 1 5.755-5.756 5.762 5.762 0 0 1 -5.755 5.756zm0-9.512a3.756 3.756 0 1 0 3.755 3.756 3.759 3.759 0 0 0 -3.755-3.756z' />
                    </svg>
                  </a>
                </li>
              ) : (
                <li onClick={() => setFormModal(applicantFormNum)}>
                  <a title='Add Applicants'>
                    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 74 74'>
                      <path d='m68.77 54.08h-3.5a1 1 0 0 1 0-2h3.5a1.221 1.221 0 0 0 1.091-1.78 1.013 1.013 0 0 1 -.08-.213l-3.149-12.4a2.307 2.307 0 0 0 -2.012-1.167h-55.24a2.307 2.307 0 0 0 -2.012 1.166l-3.149 12.4a1.013 1.013 0 0 1 -.08.213 1.221 1.221 0 0 0 1.091 1.781h24.52a1 1 0 0 1 0 2h-24.52a3.221 3.221 0 0 1 -2.923-4.587l3.154-12.419a.974.974 0 0 1 .079-.211 4.3 4.3 0 0 1 3.84-2.343h55.24a4.3 4.3 0 0 1 3.84 2.343.974.974 0 0 1 .079.211l3.154 12.419a3.221 3.221 0 0 1 -2.923 4.587z' />
                      <path d='m53.37 54.08h-9.12a1 1 0 0 1 0-2h9.12a1 1 0 0 1 0 2z' />
                      <path d='m60.17 54.08h-1.7a1 1 0 0 1 0-2h1.7a1 1 0 0 1 0 2z' />
                      <path d='m55.2 36.522h-8.942a1 1 0 0 1 -1-1v-3.267a1 1 0 1 1 2 0v2.267h6.942v-2.267a1 1 0 1 1 2 0v3.267a1 1 0 0 1 -1 1z' />
                      <path d='m60.351 36.522h-19.244a1 1 0 0 1 -1-1v-4.056a6.525 6.525 0 0 1 6.519-6.517h8.206a6.525 6.525 0 0 1 6.519 6.517v4.056a1 1 0 0 1 -1 1zm-18.244-2h17.244v-3.056a4.523 4.523 0 0 0 -4.519-4.517h-8.206a4.523 4.523 0 0 0 -4.519 4.517z' />
                      <path d='m50.729 22.85a5.756 5.756 0 1 1 5.755-5.756 5.762 5.762 0 0 1 -5.755 5.756zm0-9.512a3.756 3.756 0 1 0 3.755 3.756 3.759 3.759 0 0 0 -3.755-3.756z' />
                      <path d='m41.472 62.662h-8.944a1 1 0 0 1 -1-1v-3.268a1 1 0 0 1 2 0v2.268h6.944v-2.268a1 1 0 0 1 2 0v3.268a1 1 0 0 1 -1 1z' />
                      <path d='m46.621 62.662h-19.242a1 1 0 0 1 -1-1v-4.056a6.525 6.525 0 0 1 6.521-6.518h8.2a6.525 6.525 0 0 1 6.517 6.518v4.056a1 1 0 0 1 -.996 1zm-18.242-2h17.242v-3.056a4.523 4.523 0 0 0 -4.521-4.518h-8.2a4.523 4.523 0 0 0 -4.517 4.518z' />
                      <path d='m37 48.989a5.756 5.756 0 1 1 5.756-5.755 5.762 5.762 0 0 1 -5.756 5.755zm0-9.511a3.756 3.756 0 1 0 3.756 3.756 3.76 3.76 0 0 0 -3.756-3.756z' />
                      <path d='m27.742 36.522h-8.942a1 1 0 0 1 -1-1v-3.267a1 1 0 1 1 2 0v2.267h6.942v-2.267a1 1 0 1 1 2 0v3.267a1 1 0 0 1 -1 1z' />
                      <path d='m32.893 36.522h-19.244a1 1 0 0 1 -1-1v-4.056a6.525 6.525 0 0 1 6.519-6.517h8.206a6.525 6.525 0 0 1 6.519 6.517v4.056a1 1 0 0 1 -1 1zm-18.244-2h17.244v-3.056a4.523 4.523 0 0 0 -4.519-4.517h-8.206a4.523 4.523 0 0 0 -4.519 4.517z' />
                      <path d='m23.271 22.85a5.756 5.756 0 1 1 5.755-5.756 5.762 5.762 0 0 1 -5.755 5.756zm0-9.512a3.756 3.756 0 1 0 3.755 3.756 3.759 3.759 0 0 0 -3.755-3.756z' />
                    </svg>
                  </a>
                </li>
              )}
            </ul>
          ) : null}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

const mapStateToProps = (state, props) => {
  // const userId = props.match.params.id;
  return {
    userId: authUserIdSelector(state),
    isLoading: usersIsLoadingSelector(state),
    artisanTag: artisanTagByIdSelector(state),
    // userSettings: userSettingsSelector(state),
    userSettings: authCurrentUserSettings(state),
    userType: authCurrentUserTypeSelector(state),
    userDefaultType: authCurrentDefaultTypeSelecetor(state)
  };
};

export default connect(mapStateToProps, {
  getUser: getUserAction,
  updateUser: updateCurrnetUserSettingsAction,
  // updateUser: updateUserSettingsAction,
  getArtisanTags: getArtisanTagsAction,
  createArtisanTag: createArtisanTagAction,
  updateArtisanTag: updateArtisanTagAction,
  UpdateUserType: updateUserAction
})(Switcher);
